module.exports = __webpack_public_path__ + "img/26-jeep-grand-cherokee-l.af87635b.jpg";